<template lang="pug">
  .section-layout
    .nav-back-btn(@click="goBack")
    .content-wrapper
      h2 活动详情
      .activity-wrapper
        //- 预览区域
        .phone-wrapper
          .phone-contents
            .phone-header
              .phone-top
                img(width="375", src="../../assets/template/mobile-header.png")
              .phone-head
                .phone-title {{info.title}}
                img(class="phone-icon", src="../../assets/template/mobile-button.png")
            //- .banner
            //-   .title {{info.title}}

            .phone-content(v-if="info.relation.length")
              .phone-item-box(v-for="(item, index) in info.relation")
                .phone-item(@click="changeItem(index, item)")
                  .editor-wrapper(v-if="item.type === 1")
                    .content-title
                      .left-icon
                      div {{info.activity_content.title}}
                      .right-icon
                    div(v-html="info.activity_content.content")
                    .flower
                  .enroll-wrapper
                    img(width="100%", src="../../assets/template/mobile-enroll-box.png", v-if="item.type === 2")
                  .goods-wrapper(v-if="item.type === 3 || item.type === 4")
                    goods(:goodsItem="item")
                  .card-wrapper(v-if="item.type === 5")
                    card(:cardItem="item")
                  .help-wrapper(v-if="item.type === 9")
                    help(:helpItem="info.help_info", :start-time="info.start_time", :end-time="info.end_time")
</template>

<script>
import Api from '@/mixins/modules/Content'
import Goods from '@/components/content/modal/Goods'
import Card from '@/components/content/modal/Card'
import Help from '@/components/content/modal/HelpBoss'
import FormateDate from '@/mixins/utilities/formateDate'

export default {
  name: 'ContentCreate',
  mixins: [Api, FormateDate],
  components: {
    Goods,
    Card,
    Help,
  },
  data () {
    return {
      // 1、内容，2、报名，3、商品，4、服务，5、养护卡，6、拼团，7、秒杀，8、优惠券
      info: {
        title: '', // 标题
        brand: {}, // 选择的品牌
        cover: '', // 封面图
        description: '', // 活动简介
        goods_data: [], // 商品列表
        service_data: [], // 服务列表
        upkeep_card_data: [], // 养护卡列表
        content: [], // 活动关联项目内容
        start_time: '',
        end_time: '',
        help_info: {
          duration: '', // 助力时长
          num: '', // 助力人数
          rule: '', // 助力规则
          limit: 0, // 参与助力限制 0 无限制, 1 新用户
          launch_num: 1, // 发起次数
          assist_num: 1, // 参与次数
          type: 1,
          coupon_ids: [], // 优惠券id
          coupon_items: [], // 优惠券
        },
        activity_content: { // 活动内容数据
          title: '',
          content: '',
        },


        relation: [], // 活动组件
      },
    }
  },
  watch: {},
  methods: {
    // 返回列表页
    goBack () {
      this.$router.push({
        name: 'contentListBoss',
        query: {
          save: 1,
        },
      })
    },
    // 获取活动详情
    async activityDetail () {
      try {
        const { response, result } = await this.GetActivityBossDetailApi({
          activity_id: this.activity_id,
        })
        if (response.status === 200) {
          console.log('result.data', result.data)
          this.info.activity_id = result.data.activity_id
          this.info.title = result.data.title
          this.info.brand = {
            brand_id: result.data.brand_id,
            brand_name: result.data.brand_name,
          }
          this.info.cover = result.data.cover
          this.info.description = result.data.description
          if (result.data.start_time) {
            this.info.start_time = this.formateDate(result.data.start_time, false, 2)
            this.info.end_time = this.formateDate(result.data.end_time, false, 2)
          }
          let relation = []
          result.data.relation.forEach(item => {
            switch (item.type) {
              case 1:
                relation.push({
                  type: 1,
                })
                this.info.activity_content.title = item.object_extra.title
                this.info.activity_content.content = item.object_extra.content.replace(/<img/g, '<img style="max-width:100%;height:auto" ')
                break
              case 2:
                relation.push({
                  type: 2,
                })
                break
              case 3:
                relation.push({
                  type: 3,
                  product_id: item.item_id,
                  name: item.item_name,
                  product_pic: item.item_pic,
                  mini_price: item.sell_price,
                  pic: item.item_pic,
                })
                break
              case 4:
                relation.push({
                  type: 4,
                  product_id: item.item_id,
                  product_pic: item.item_pic,
                  name: item.item_name,
                  mini_price: item.sell_price,
                  pic: item.item_pic,
                })
                break
              case 5:
                relation.push({
                  type: 5,
                  id: item.item_id,
                  image_url: item.item_pic,
                  name: item.item_name,
                  num: item.num,
                  price: item.sell_price,
                  origin_price: item.origin_price,
                })
                break
              case 9:
                relation.push({
                  type: 9,
                })
                let content = item.content
                this.info.help_info = {
                  duration: content.duration,
                  num: content.num,
                  rule: content.rule, // 助力规则
                  limit: content.limit, // 参与助力限制 0 无限制, 1 新用户
                  launch_num: content.launch_num, // 发起次数
                  type: 1,
                  assist_num: content.assist_num, // 参与次数
                  coupon_items: content.coupon, // 优惠券id,
                  extend: content.extend,
                }
                break
              default:
                break
            }
          })
          this.info.relation = relation
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取活动详情失败',
            content: `出错啦！错误码：${response.status}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取活动详情失败',
          content: `出错啦！错误码：${err}`,
        })
      }
    },
  },
  mounted () {
    this.activity_id = this.$route.query.id
    this.activityDetail() // 获取活动详情
  },
}
</script>

<style scoped lang="stylus">
@import '~@/stylus/modules/creation-modal'
.nav-back-btn
  position absolute
  top 36px
  left 16px
  width 32px
  height 32px
  border-radius 100%
  background #CED3DC center no-repeat url('~@/assets/back.svg')
  background-size 16px
  box-shadow 0 2px 6px 0 rgba(0, 0, 0, 0.08)
  cursor pointer
  z-index 2
.editor-wrapper
  position: relative
  margin-bottom: 15px
  padding: 25px 20px 25px 20px
  min-height: 200px
  word-wrap break-word
  border: 5px solid #E8C18E
  background: #ff
  .content-title
    display: flex
    align-items: center
    justify-content: space-around
    margin-bottom: 20px
    font-size: 16px
    color: #404040
    .left-icon, .right-icon
      width: 40px
      height: 6px
    .left-icon
      background: url('https://chedian-oss1.vchangyi.com/images/assets/content-left.png')
      background-size: cover
    .right-icon
      background: url('https://chedian-oss1.vchangyi.com/images/assets/content-right.png')
      background-size: cover
  .flower
    position: absolute
    bottom: 0
    right: -10px
    width: 25px
    height: 115px
    background: url('https://chedian-oss1.vchangyi.com/images/assets/content-icon.png')
    background-size: cover
.enroll-wrapper
  margin-bottom 20px
.activity-wrapper
  padding 12px
  display flex
  justify-content center
.phone-wrapper
  flex 0 0 500px
  overflow-x hidden
  overflow-y auto
  .phone-contents
    width 375px
    background #F6F0E8
    border 1px solid #E4E4E4
.phone-header
  position relative
  width 373px
  background #fff
  .phone-head
    position relative
    height 42px
    line-height 42px
    text-align center
    .phone-title
      margin 0 auto
      width 160px
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
    .phone-icon
      position absolute
      top 3px
      right 8px
      width 87px
      height 32px
// .banner
//   display flex
//   justify-content center
//   margin-bottom 15px
//   width: 100%
//   height: 485px
//   background: url('https://chedian-oss1.vchangyi.com/images/assets/banner.png')
//   background-size: cover
//   .title
//     margin-top 50px
//     width 272px
//     height 94px
//     line-height: 47px
//     font-size 34px
//     text-align center
//     word-wrap break-word
//     color #F3CC9F
.phone-content
  padding-top 15px
  .phone-item-box
    margin 2px 0
    position relative
    .phone-item
      padding 0 15px
      min-height 112px
      background #F6F0E8
</style>



// WEBPACK FOOTER //
// src/components/content/ContentDetailBoss.vue